module.exports = __webpack_public_path__ + "static/media/5@1920w.1a1da779.jpg";